import { catchError, of, switchMap } from 'rxjs';
import { ofType } from 'redux-observable';
import { unsubscribeMarketingCampaign$, unsubscribeFeedback$ } from '../apis/postsMarketingCampaign';
import unsubcribeSlice from './slices';

const actions = unsubcribeSlice.actions;

/**
 * Epic to POST the unsubscribe perferences
 * You can see a list of the preferences chosen 
 * from the menu in the unsubscribe page
 */
export const unsubscribeEpic = (action$) =>
  action$.pipe(
    ofType(actions.fetchUnsubscribe.type),
    switchMap((action) => {
      const payload = {...action.payload};
      return unsubscribeMarketingCampaign$(payload).pipe(
        switchMap(() => of(actions.fetchUnsubscribeSucces())),
        catchError(() => of(actions.fetchUnsubscribeError())),
      );
    })
  );

  
/**
 * Epic to POST the unsubscribe perferences
 * You can see a list of the preferences chosen 
 * from the menu in the unsubscribe page
 */
export const unsubscribeFeedbackEpic = (action$) =>
action$.pipe(
  ofType(actions.fetchUnsubscribeFeedback.type),
  switchMap((action) => {
    const payload = {...action.payload};
    return unsubscribeFeedback$(payload).pipe(
      switchMap(() => of(actions.fetchUnsubscribeSucces())),
      catchError(() => of(actions.fetchUnsubscribeError())),
    );
  })
);